import { createContext } from 'react'
import { Rollouts } from './getRollouts'

export const RolloutsContext = createContext<Rollouts>({
  newSearchOn: false,
  modelSelectOn: false,
})
